import {
  Button,
  Icons,
  Show,
  Space,
  Typography,
} from "@pankod/refine-antd";
import {
  IResourceComponentsProps,
  useNavigation,
  useShow,
} from "@pankod/refine-core";
import { useParams } from "@pankod/refine-react-router-v6";

import { IFeatureFlag } from "interfaces/feature-flags";
import { FeatureFlagsHeaderBreadcrumb } from "./components/feature-flags-header-breadcrumb";
import {
  FEATURE_FLAGS_LIST_PATH,
  FEATURE_FLAGS_RESOURCE,
} from "./utils/feature-flags.constants";
import {
  getFeatureFlagContextLabel,
  getFeatureFlagStatusLabel,
  getFeatureFlagTypeLabel,
} from "./utils/feature-flags.helpers";

const { Title, Text } = Typography;

const renderTextValue = (value?: string | null) => value || "-";

const renderTags = (values?: string[]) =>
  values?.length ? values.join(", ") : "-";

const renderDetailField = (label: string, value: string) => (
  <div style={{ marginBottom: 18 }}>
    <Title level={5} style={{ marginBottom: 4 }}>
      {label}
    </Title>
    <Text type="secondary">{value}</Text>
  </div>
);

export const FeatureFlagsShow: React.FC<IResourceComponentsProps> = () => {
  const { edit, push } = useNavigation();
  const { id } = useParams();
  const { queryResult, showId } = useShow<IFeatureFlag>({
    resource: FEATURE_FLAGS_RESOURCE,
    id,
  });
  const { data, isLoading, refetch } = queryResult;
  const record = data?.data;
  const recordId = record?.key ?? showId;

  return (
    <Show
      title="Visualizar"
      isLoading={isLoading}
      breadcrumb={<FeatureFlagsHeaderBreadcrumb />}
      contentProps={{
        style: {
          backgroundColor: "#FCFBFC",
          border: "1px solid #DADADA",
        },
        bodyStyle: {
          padding: 0,
          backgroundColor: "#FCFBFC",
        },
      }}
      headerButtons={
        <Space>
          <Button onClick={() => push(FEATURE_FLAGS_LIST_PATH)}>Controle</Button>
          <Button icon={<Icons.ReloadOutlined />} onClick={() => refetch()}>
            Refresh
          </Button>
          <Button
            type="primary"
            icon={<Icons.EditOutlined />}
            disabled={!recordId}
            onClick={() => recordId && edit(FEATURE_FLAGS_RESOURCE, recordId)}
          >
            Editar
          </Button>
        </Space>
      }
    >
      <div
        style={{
          backgroundColor: "#FCFBFC",
          minHeight: 260,
          padding: "24px 28px",
        }}
      >
        {renderDetailField("Nome", renderTextValue(record?.name))}
        {renderDetailField("Key", renderTextValue(record?.key))}
        {renderDetailField(
          "Status",
          getFeatureFlagStatusLabel(Boolean(record?.enabled)),
        )}
        {renderDetailField(
          "Tipo",
          record?.flag_type ? getFeatureFlagTypeLabel(record.flag_type) : "-",
        )}
        {renderDetailField(
          "Contexto",
          record?.contexts ? getFeatureFlagContextLabel(record.contexts) : "-",
        )}
        {renderDetailField(
          "Repositório (consumo)",
          renderTags(record?.target_repos),
        )}
        {renderDetailField("Tags", renderTags(record?.tags))}
      </div>
    </Show>
  );
};
